<template>
  <section class="l-calendar-grid c-calendar__card-group">
    <div class="c-calendar__kolonne">
      <span class="c-calendar__kolonne-number">{{ kolonne_number }}</span>
    </div>
    <div class="l-calendar-grid__cell" v-for="(date, i) in this.days_of_week" :key="i">
      <v-week-day
        :row_id="id"
        :id="i"
        :index="index"
        :kolonne_number="kolonne_number"
        :date="date"
        :weekday_objects="weekday_objects"
        :week_results="week_results"
        :holidays="holidays"
      ></v-week-day>
    </div>
  </section>
</template>

<script>
import WeekDay from "./weekDay";

export default {
  name: "weekRow",
  props: {
    id: {
      type: Number,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    kolonne_number: {
      type: String,
      default: ""
    },
    days_of_week: {
      type: Array,
      default: () => []
    },
    week_results: {
      type: Array,
      default: () => []
    },
    weekday_objects: {
      type: Array,
      default: () => []
    },
    holidays: {
      type: Object,
      default: {}
    }
  },
  components: {
    vWeekDay: WeekDay
  },

  data: function() {
    return {};
  }
};
</script>